// Typed failures of the online layer. Boundaries catch these by type; anything else is a bug and propagates.

/** Input from a peer (a client, the edge, PlayFab) does not have the agreed shape. */
export class WireFormatError extends Error {
  override readonly name = 'WireFormatError'
}

/** A programmer error inside the online layer or one of its hosts. */
export class OnlineInvariantError extends Error {
  override readonly name = 'OnlineInvariantError'
}

/** A host was deployed without a setting it needs (a missing secret, a half-configured backend). */
export class OnlineConfigError extends Error {
  override readonly name = 'OnlineConfigError'
}

export const ClaimRejection = {
  malformed: 'malformed',
  badSignature: 'bad_signature',
  expired: 'expired',
  wrongRoom: 'wrong_room',
  wrongRoute: 'wrong_route',
} as const
export type ClaimRejection = (typeof ClaimRejection)[keyof typeof ClaimRejection]

/** A seat claim that does not admit its bearer (docs/NETTEST.md "Seat claims"). */
export class ClaimRejected extends Error {
  override readonly name = 'ClaimRejected'

  constructor(readonly reason: ClaimRejection) {
    super(`seat claim rejected: ${reason}`)
  }
}
